import gql from 'graphql-tag';
import userRolesFragment from '../fragments/userRoles';

const ADD_WORKSPACE_USER_ROLE = gql`
  mutation AddWorkspaceUserRole($userId: ID!, $roleId: ID!, $workspaceId: ID!) {
    addWorkspaceUserRole(
      userId: $userId
      roleId: $roleId
      workspaceId: $workspaceId
    ) {
      id
      userId_
      roleId
      role {
        id
        name
      }
    }
  }
`;

const REMOVE_WORKSPACE_USER_ROLE = gql`
  mutation RemoveWorkspaceUserRole($userRoleId: ID!, $workspaceId: ID!) {
    removeWorkspaceUserRole(
      userRoleId: $userRoleId
      workspaceId: $workspaceId
    ) {
      affectedRows
      inserted
      updated
      deleted
      errors
    }
  }
`;

const REMOVE_CUSTOMER_MEMBER = gql`
  mutation RemoveCustomerMember($userId: ID!, $customerId: ID!) {
    removeCustomerMember(userId: $userId, customerId: $customerId) {
      affectedRows
    }
  }
`;

const UPDATE_USER_ROLE_BY_WORKSPACE_ID = gql`
  mutation UpdateUserRoleByWorkspace(
    $userId: ID!
    $workspaceId: ID!
    $roleId: ID!
  ) {
    updateUserRoleByWorkspace(
      userId: $userId
      workspaceId: $workspaceId
      roleId: $roleId
    ) {
      ...userRoleDetails
    }
  }

  ${userRolesFragment.FRAGMENT_USER_ROLES}
`;

const UPDATE_USER_ROLE_BY_CUSTOMER_ID = gql`
  mutation UpdateUserRoleByCustomerId(
    $userId: ID!
    $customerId: ID!
    $roleId: ID!
  ) {
    updateUserRoleByCustomerId(
      userId: $userId
      customerId: $customerId
      roleId: $roleId
    ) {
      ...userRoleDetails
    }
  }

  ${userRolesFragment.FRAGMENT_USER_ROLES}
`;

const SET_CUSTOMER_MEMBER_ALL = gql`
  mutation SetCustomerMemberAll($userId: ID!, $customerId: ID!, $roleId: ID!) {
    setCustomerMemberAll(
      userId: $userId
      customerId: $customerId
      roleId: $roleId
    ) {
      affectedRows
      inserted
      updated
      deleted
    }
  }
`;

const SET_CUSTOMER_MEMBER_DEVICES = gql`
  mutation SetCustomerMemberDevices(
    $userId: ID!
    $customerId: ID!
    $roleId: ID!
    $deviceIds: [ID!]!
  ) {
    setCustomerMemberDevices(
      userId: $userId
      customerId: $customerId
      roleId: $roleId
      deviceIds: $deviceIds
    ) {
      affectedRows
      inserted
      updated
      deleted
    }
  }
`;

export default {
  ADD_WORKSPACE_USER_ROLE,
  REMOVE_WORKSPACE_USER_ROLE,
  REMOVE_CUSTOMER_MEMBER,
  UPDATE_USER_ROLE_BY_WORKSPACE_ID,
  UPDATE_USER_ROLE_BY_CUSTOMER_ID,
  SET_CUSTOMER_MEMBER_ALL,
  SET_CUSTOMER_MEMBER_DEVICES,
};
